module.exports = __webpack_public_path__ + "media/bootstrap-icons/snow2-1e14af75.svg";